import { ProductEvaluationTaskStatusEnum } from "./enums/ProductEvaluationTaskStatusEnum"

export class AvailableActions {
  actions: Action[]
  messages: MessageAction[]
}

export class Action {
  currentStatus: string
  nextStatus: ProductEvaluationTaskStatusEnum
  class: any
  title: string
  actionId: number
  apiName: string
}
export class MessageAction {
  message: string
  image: string
}
